// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"2df8e779","135":"4557dd5e","183":"8f8f00fd","426":"cf99a08d","651":"602c8c86","872":"1c606036"}[chunkId] + ".chunk.js";
};